import { AccountingEntriesFieldsConfiguration, DescriptionOption } from '~modules/connectors/services/extract-connectors-configurations/field-type';
import { clientThirdPartTemplatingNameFieldOption, clientThirdPartyTemplatingOptions, defaultEntryDescriptionEmptyFieldOption, defaultEntryLineDescriptionStandardFieldOption, defaultGroupingDescriptionEmptyFieldOption, getPaymentEntryDescriptionFieldOptions, getPaymentEntryLineDescriptionFieldOptions, getPaymentGroupingDescriptionFieldOptions, supplierThirdPartTemplatingNameFieldOption, supplierThirdPartyTemplatingOptions } from './default-transformation-fields';
import { JournalOptionEnum } from '~modules/connectors/constants/journal.options';
import { ReverseChargeAggregateOptionEnum } from '~modules/connectors/constants/reverse-charge-aggregate.options';


const payplugPaymentGroupingDescriptionOptions: DescriptionOption[] = getPaymentGroupingDescriptionFieldOptions();

const payplugPaymentEntryDescriptionOptions: DescriptionOption[] = getPaymentEntryDescriptionFieldOptions({
    withThirdPart: true
});

const payplugPaymentEntryLineDescriptionOptions: DescriptionOption[] = getPaymentEntryLineDescriptionFieldOptions({
    withThirdPart: true
});

export const payplugTransformationFieldsConfiguration: AccountingEntriesFieldsConfiguration = {
    toolLabel: 'Payplug',

    paymentProcessorConfiguration: {
            journalOption: {
                visible: false,
                defaultValue: JournalOptionEnum.UNIQUE,
            },
            uniqueJournal: {
                code: {
                    defaultValue: 'PPG'
                },
                label: {
                    defaultValue: 'Payplug'
                }
            },
            client: {
                useSuggestedAccounts: {
                    visible: false,
                    defaultValue: false
                },
                account: {
                    defaultValue: '411'
                },
                label: {
                    defaultValue: 'Clients'
                },
                isDynamic: {
                    defaultValue: false
                },
                auxiliaryLabelStatic: {
                    defaultValue: 'PAYPLUG'
                },
                auxiliaryAccountStatic: {
                    defaultValue: 'PAYPLUG'
                },
                auxiliaryDynamic: {
                    options: clientThirdPartyTemplatingOptions,
                    defaultOption: clientThirdPartTemplatingNameFieldOption
                }
            },
            supplier: {
                useSuggestedAccounts: {
                    visible: false,
                    defaultValue: false
                },
                account: {
                    defaultValue: '401'
                },
                label: {
                    defaultValue: 'Fournisseurs'
                },
                isDynamic: {
                    visible: false,
                    defaultValue: false
                },
                auxiliaryLabelStatic: {
                    defaultValue: 'PAYPLUG'
                },
                auxiliaryAccountStatic: {
                    defaultValue: 'PAYPLUG'
                },
                auxiliaryDynamic: {
                    options: supplierThirdPartyTemplatingOptions,
                    defaultOption: supplierThirdPartTemplatingNameFieldOption
                }
            },
            useSuggestedProviderAccounts: {
                visible: false,
                defaultValue: false
            },
            methods: {
                unique: true,
                defaultMethod: {
                    name: null,
                    export: true,
                    journalCode: null,
                    internalTransfer: {
                        account: '581',
                        label: 'Virement interne PAYPLUG'
                    },
                    provider: {
                        account: '5171',
                        label: 'PAYPLUG'
                    },
                    bankSupplier: {
                        account: '401',
                        label: 'Fournisseurs',
                        auxiliaryAccount: 'PAYPLUG',
                        auxiliaryLabel: 'PAYPLUG'
                    }
                }
            },
            providerFee: {
                visible: false,
                account: {
                    defaultValue: '62781'
                },
                label: {
                    defaultValue: 'Autres frais et commissions sur prestations de services'
                }
            },
            deductibleVat20: {
                visible: false,
                account: {
                    defaultValue: '44566'
                },
                label: {
                    defaultValue: 'TVA sur autres biens et services'
                }
            },
            reverseCharge: {
                visible: false,
                has: {
                    defaultValue: false
                },
                aggregateOption: {
                    defaultValue: ReverseChargeAggregateOptionEnum.EACH
                },
                collectedIntracomVat: {
                    account: {
                        defaultValue: '4452'
                    },
                    label: {
                        defaultValue: 'TVA due intracommunautaire'
                    }
                },
                deductibleIntracomVat: {
                    account: {
                        defaultValue: '445662'
                    },
                    label: {
                        defaultValue: 'TVA intracommunautaire sur autres biens et services'
                    }
                },
                vatRate: {
                    defaultValue: 20.00
                }
            },
            useSuggestedCounterpartAccounts: {
                visible: false,
                defaultValue: false
            },
            undefinedCredit: {
                visible: false,
                account: {
                    defaultValue: '471'
                },
                label: {
                    defaultValue: 'Opérations à reclasser'
                }
            },
            undefinedDebit: {
                visible: false,
                account: {
                    defaultValue: '471'
                },
                label: {
                    defaultValue: 'Opérations à reclasser'
                }
            },
            groupingDescription: {
                visible: false,
                options: payplugPaymentGroupingDescriptionOptions,
                defaultOption: defaultGroupingDescriptionEmptyFieldOption
            },
            entryDescription: {
                options: payplugPaymentEntryDescriptionOptions,
                defaultOption: defaultEntryDescriptionEmptyFieldOption,
            },
            entryLineDescription: {
                options: payplugPaymentEntryLineDescriptionOptions,
                defaultOption: defaultEntryLineDescriptionStandardFieldOption,
            }
        },

    analyticProcessorConfiguration: {
        isEnabled: {
            defaultValue: false
        },
        accountRules: {}
    }
}